import { useCallback } from 'react';

import { participantColors, getParticipantColor } from '@atlaskit/editor-shared-styles';
import { getAnonymousAvatarWithStyling } from '@atlaskit/anonymous-assets';

export const useAnonymousAsset = () => {
	const fetchAnonymousAsset = useCallback((id: string | undefined) => {
		const color = id
			? getParticipantColor(id).color.backgroundColor
			: participantColors[0].backgroundColor;

		return getAnonymousAvatarWithStyling({
			styleProperties: {
				'background-color': color,
			},
		});
	}, []);

	return {
		fetchAnonymousAsset,
	};
};
